<template>
  <div class="filter">
    <CloseButton mode="closeFilter" @click="redirectHome" />
    <!--1. Form-->
    <form
      v-if="filterResults.length === 0 && filterError === false"
      @submit.prevent="submitFilter"
    >
      <!--2. Properties -->
      <template v-for="filter in filterOptions" :key="filter.classId">
        <!--2.1 Properties: Hardness and Density -->
        <div
          class="filter--input"
          v-if="filter.classId === 'hardness' || filter.classId === 'density'"
        >
          <label :for="filter.classId">{{ filter.classText }}:</label>
          <input
            type="number"
            :id="filter.classId"
            :name="filter.classText"
            min="1"
            :max="`${filter.classId === 'hardness' ? 10 : 20}`"
            placeholder="0"
            @change="handleQueryNumber"
          />
          <p>
            (Min: 1 - Max: {{ filter.classId === "hardness" ? "10" : "19" }})
          </p>
        </div>
        <!--2.2 Properties: Other -->
        <div class="filter--child" v-else>
          <FilterChild
            :filter-categories="filter.categories"
            :filter-class="filter.classText"
            :filter-id="filter.classId"
            @category-chosen="handleCategory"
          />
        </div>
      </template>
      <!--2.3 Submit Button -->
      <ActionButton v-if="getCurrentLanguage === 'pt'" mode="filterBtn">
        Vamos! 🔎
      </ActionButton>
      <ActionButton v-else mode="filterBtn"> Go! 🔎 </ActionButton>
    </form>
    <!--3. Results-->
    <div v-if="filterResults.length > 0" class="filter--results">
      <template v-for="mineral in filterResults" :key="mineral.idName">
        <MineralCard
          :main-properties="mineral"
          photo-size="minFilterCard"
          mode="filterCards"
        />
      </template>
    </div>
    <!--4. Error -->
    <div v-if="filterError === true" class="filter--error">
      <h3 v-if="getCurrentLanguage === 'pt'">
        Não encontrado neste banco de dados 😭
      </h3>
      <h3 v-else>No match in this database 😭</h3>
      <ul class="query" v-for="query in queryArray" :key="query[0]">
        <li>{{ query[0] }}: {{ query[1] }} ❌</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import FilterChild from "./FilterChild.vue";
import ActionButton from "@/components/buttons/ActionButton.vue";
import CloseButton from "@/components/buttons/CloseButton.vue";

import MineralCard from "./MineralCard.vue";

const store = useStore();
const router = useRouter();

/**
 * chosen filter parameters
 */
const chosenObj = ref({});

onBeforeMount(() => {
  /**
   * upload the form options
   */
  store.dispatch("minerals/getFilterOptions");
});

/**
 * gets array of form option object
 */
const filterOptions = computed(() => {
  return store.getters["minerals/loadFilterOptions"];
});

/**
 * returns array of mineral objects
 */
const filterResults = computed(() => {
  return store.getters["minerals/getFilterResults"];
});

/**
 * gets error if there is no match
 */
const filterError = computed(() => {
  return store.getters["minerals/getFilterError"];
});

/**
 * @returns {String} of the user language
 */
const getCurrentLanguage = computed(() => {
  return store.getters.getCurrentLanguage;
});

/**
 * @returns { Array } of arrays with parameter pairs
 */
const queryArray = computed(() => {
  return store.getters["minerals/hasQuery"];
});

/**
 *
 * @param c is an array of parameter pairs, to be saved in chosenObj
 */
function handleCategory(c) {
  let key = c[0];
  if (key === "crystalsystem") {
    key = "crystal";
  }
  chosenObj.value[key] = c[1];
}

/**
 *
 * @param n is an array of parameter pairs for density and hardness
 */
function handleQueryNumber(n) {
  chosenObj.value[n.target.id] = +n.target.value;
}

/**
 * function to submit the form
 */
function submitFilter() {
  let queryArray = Object.entries(chosenObj.value);
  queryArray = queryArray.filter((el) => el[1] !== "" && el[1] !== null);
  store.dispatch("minerals/getFilterResults", queryArray);
  chosenObj.value = [];
}

/**
 * function to sent the user to the minerals home
 */
function redirectHome() {
  router.push("/minerals");
}
</script>

<style lang="css" scoped>
.filter {
  color: var(--color-grey-4);
  margin-top: -5vh;
  width: 60vw;
  height: auto;
  font-size: 2rem;
  background-color: #f4fce3;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  padding: 3rem;
  position: relative;
  z-index: 2000;
}
@media only screen and (max-width: 1250px) {
  .filter {
    margin-top: 0px;
  }
}
@media only screen and (max-width: 764px) {
  .filter {
    width: 80vw;
  }
}
@media only screen and (max-width: 600px) {
  .filter {
    margin-top: -5vh;
    width: 90vw;
  }
}
@media only screen and (max-width: 500px) {
  .filter {
    width: 95vw;
  }
}
form {
  display: flex;
  flex-direction: column;
}
form > div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/** density and hardness */
.filter--input {
  height: 3vh;
  margin-top: 3rem;
  text-transform: uppercase;
}

label {
  width: 15vw;
  font-family: var(--font-display);
}
input {
  width: 5rem;
}
p {
  margin-left: 1rem;
}
@media only screen and (max-width: 600px) {
  .filter--input {
    width: 50vw;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 30% 70%;
    margin-left: 20vw;
  }
  label {
    grid-row: 1/2;
    grid-column: 1/-1;
  }
  input {
    grid-row: 2/3;
    grid-column: 1/2;
  }
  p {
    grid-row: 2/3;
    grid-column: 2/3;
  }
}
@media only screen and (max-width: 500px) {
  .filter--input {
    width: 40vw;
    margin-left: 22vw;
    grid-template-columns: 20% 80%;
  }
}

/** mineral results */
.filter--results {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.min {
  background-color: lightpink;
}

/** error message */
.filter--error {
  width: 100%;
  height: 40vh;
  background-color: oklch(71.2% 0.194 13.428);
  z-index: 2000;
  text-transform: capitalize;
  text-align: center;
  padding-top: 5rem;
  padding-bottom: 3rem;
  position: relative;
  animation-name: falling;
  animation-duration: 3s;
}

.closeBtn {
  position: absolute;
  top: 2rem;
  right: 2rem;
  color: var(--color-grey-4);
}

h3 {
  font-family: var(--font-display);
  padding-bottom: 3rem;
  text-transform: uppercase;
}
.query {
  font-size: 2rem;
  text-align: center;
}

ul {
  list-style: none;
}
li {
  text-transform: uppercase;
  font-size: 2rem;
}
@keyframes falling {
  from {
    transform: translateY(-10rem);
  }
  to {
    transform: translate(0);
  }
}

@media only screen and (max-width: 600px) {
  .filter--child {
    display: flex;
    flex-direction: column;
  }
}
</style>
